import * as S from './ModalStyle';

interface ModalProps {
  onClose: () => void;
}

export default function TicketDuplication({ onClose }: ModalProps) {
  return (
    <S.ModalOverlay>
      <S.ModalContainer>
        <S.ModalTitle>입장권 중복 예매</S.ModalTitle>
        <S.ModalContent>
          <S.Summary>
            입력하신 전화번호로
            <br /> 예매 내역이 존재합니다.
          </S.Summary>
          <S.Summary>
            1개의 전화번호당
            <br /> 1회만 예매 가능합니다.
          </S.Summary>
          <S.AskMethod>
            *입장권 관련 문의:
            <br />{' '}
            <a
              href="https://pf.kakao.com/_Ixexiwn"
              style={{ textDecoration: 'underline' }}
            >
              https://pf.kakao.com/_Ixexiwn
            </a>
          </S.AskMethod>
        </S.ModalContent>
        <S.CloseButton type="button" onClick={onClose}>
          확인
        </S.CloseButton>
      </S.ModalContainer>
    </S.ModalOverlay>
  );
}
